import invokeSmartScripts from './smart-script';

document.addEventListener('DOMContentLoaded', function(e) {
    invokeSmartScripts(document);
});
